export const aiChatbotStoreKey = 'aiChatbot';
